module.exports = __webpack_public_path__ + "img/icon-user.a5479feb.svg";